/**
 * Audit Log Module Configuration
 *
 * Admin-only module that surfaces the audit trail of all entity changes.
 * Appears in the sidebar for admin users.
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const auditLogModule: AppModule = {
    id: 'audit-log',

    navigation: {
        label: 'Audit Log',
        icon: 'scroll-text',
        path: '/audit-log',
        order: 80,
        moduleKey: 'audit_log',
        pages: [
            {
                label: 'All Entries',
                path: '/audit-log',
                icon: 'scroll-text',
            },
        ],
    },

    routes,
}

export default auditLogModule
